import React from 'react'
import Loader from 'react-loader-spinner'
import styled from 'styled-components'

const Div = styled.div`
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: ${props => props.theme.white};
    z-index: 3;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

`

const Loading = () => {
    return (
        <Div>
            <Loader
                type="Oval"
                color="#1aa028"
                // secondaryColor="green"
                height={100}
                //  width={100}
            />
        </Div>
    )
}

export default Loading